import {
  Button,
  Card,
  Form,
  Input,
  message,
  Radio,
} from "antd";
import "../styles/index.css";
import { useState } from "react";
import BillCard from "./BillPage";
import { TelenganaApiService } from "../httpsservice/ApiService";
import { HomeFilled } from "@ant-design/icons";
import { serviceMapper } from "../utils";

const ServicePageTG = () => {
  const [showBill, setShowBill] = useState(false);
  const [billData, setBillData] = useState(null);
  const [form] = Form.useForm();

  const [messageApi, contextHolder] = message.useMessage();
  const [isFetchLoading, setFetchLoading] = useState(false);
  const [fetchBillBtnDisabled, setFetchBillBtnDisabled] = useState(false);

  const handleSubmit = async () => {
    try {
      await callServiceNumberApi();
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const isFetchBillBtnDisabled = () => {
    if (
      form.isFieldTouched("service_number") &&
      form.getFieldValue("service_number")?.length === 9 
      // form.getFieldError("service_number").length === 0
    ) {
      setFetchBillBtnDisabled(false);
      return false;
    } else {
      setFetchBillBtnDisabled(true);
      return true;
    }
  };

  const callServiceNumberApi = async () => {
    setFetchLoading(true);
    const serviceNumber = form.getFieldValue("service_number");
    const serviceType = form.getFieldValue("service_type");

    const queryData = {
      service_number: serviceNumber,
      service_type: serviceType,
    };

    try {
      const response = await TelenganaApiService.getBillDetails(queryData);

      if (response?.data && response.success) {
        response.data.serviceType = serviceMapper[serviceType];
        response.data.uniqueSNo = serviceNumber;
        setBillData(response.data);
        setShowBill(true);
        form.setFields([{ name: "service_number", errors: [] }]);
      } else {
        setShowBill(false);
        setBillData(null);
        form.setFields([
          {
            name: "service_number",
            errors: [response?.message || "Failed to fetch bill data"],
          },
        ]);
      }
    } catch (error) {
      console.error("Error fetching bill details:", error);
      setShowBill(false);
      setBillData(null);
      form.setFields([
        {
          name: "service_number",
          errors: ["Service temporarily unavailable. Please try again later."],
        },
      ]);
    }
    setFetchLoading(false);
  };

  const redirectToHomePage = () => {
    const url = "https://tgsouthernpower.org/";
    window.location.href = url;
  };

  return (
    <>
      {contextHolder}
      <div
        className={
          showBill ? "main-wrapper-telangana-lg" : "main-wrapper-telangana-sm"
        }
      >
        <div
          className={showBill ? "center-container-lg" : "center-container-sm"}
        >
          <div className="center-box-bill">
            <div className="home-section">
              <Button
                icon={<HomeFilled style={{ color: "white" }} />}
                className="home-button"
                onClick={redirectToHomePage}
              >
                Back Home
              </Button>
            </div>

            {!showBill && !billData && (
              <Card
                className="service-number-card"
                cover={
                  <div className="tel-logo-main">
                    <img
                      alt="BSES"
                      className="tgspdcl-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tgspdcl-logo.jpg"
                    />
                    <span className="elecricity-title">
                      SOUTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED
                    </span>
                  </div>
                }
              >
                <div className="card-body-container">
                  <p>Online electricity bill payment</p>
                  <Card className="form-card">
                    <Form form={form} onFinish={handleSubmit} className="form">
                      <Form.Item name="service_type" initialValue="N">
                        <Radio.Group
                          className="radio-buttons"
                          onChange={(e) => {
                            form.setFieldsValue({
                              service_type: e.target.value,
                              service_number: undefined,
                            });
                          }}
                        >
                          <Radio value={"N"}>Postpaid Service</Radio>
                          <Radio value={"Y"}>Prepaid Service</Radio>
                        </Radio.Group>
                      </Form.Item>

                      <div className="service-number-input">
                        Service number<sup style={{ color: "red" }}>*</sup>
                      </div>

                      <Form.Item
                        name="service_number"
                        rules={[
                          {
                            required: true,
                            message: "Invalid service number",
                          },
                          {
                            pattern: /^\d{9}$/,
                            message: "Invalid service number",
                          },
                        ]}
                      >
                        <Input
                          className="service-number-input-box"
                          size="large"
                          maxLength={9}
                          placeholder="Enter Service Number"
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^\d]/g, "");
                            form.setFieldsValue({ service_number: value });
                            form.validateFields(["service_number"]);
                          }}
                        />
                      </Form.Item>

                      <Form.Item shouldUpdate>
                        {() => (
                          <Button
                            className={
                              fetchBillBtnDisabled
                                ? "fetch-bill-btn-tg-disabled"
                                : "fetch-bill-btn-tg"
                            }
                            size="large"
                            block
                            htmlType="submit"
                            loading={isFetchLoading}
                            disabled={isFetchBillBtnDisabled()}
                          >
                            Show Bill
                          </Button>
                        )}
                      </Form.Item>
                    </Form>
                  </Card>
                </div>
              </Card>
            )}

            {showBill && billData && <BillCard billData={billData} />}

            <div className="poweredby-logo-main">
              <img
                alt="poweredby-logo"
                className="poweredby-logo"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicePageTG;
